import { useState } from 'react'

// 不同页面组件触发render
export default function useRefresh() {
    const [refresh, setRefresh] = useState(false)

    return {
        refresh,
        setRefresh,
    }
}
